import React, { useEffect } from "react";
import Highcharts from "highcharts";
import { Box, Paper, Typography } from "@mui/material";

const FullViewDonutChart = (Props) => {
  console.log(Props, 6)
  useEffect(() => {
    const DonutChartData = {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 60,
        },
      },
      title: {
        text: "",
        align: "left",
      },
      exporting: false,
      subtitle: {
        text: "",
        align: "left",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          innerSize: "50%",
          depth: 45,
          dataLabels: {
            enabled: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          data: [
            {
              name: "Open",
              y: Props?.data?.open_count,
              color: "#0BB783",
            },
            {
              name: "Closed",
              y: Props?.data?.close_count,
              color: "#F64E60",
            },
            // {
            //   name: "In Progress",
            //   y: Props?.data?.in_progress_count,
            //   color: "#F64E60",
            // },
          ],
        },
      ],
    };

    Highcharts.chart("FullViewDonutChart", DonutChartData);
  }, [Props.data]);
  return (
    <>
      <Paper
        sx={{
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            padding: "20px 20px 20px 20px",
          }}
        >
          <Box>
            <div
              id="FullViewDonutChart"
              style={{
                width: "100%",
                height: "550px",
                // "text.highcharts-credits": {
                //   display: "none",
                // },
              }}
            ></div>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridGap: "20px",
            }}
          >
            <Box>
              <Typography
                sx={{ color: "#0BB783", fontWeight: "600", fontSize: "18px" }}
              >
                {Props?.data?.open_count}
              </Typography>
              <Typography>Open Defect</Typography>
            </Box>
            {/* <Box>
              <Typography
                sx={{ color: "#F64E60", fontWeight: "600", fontSize: "18px" }}
              >
                {Props?.data?.in_progress_count}
              </Typography>
              <Typography>In Progress Defect</Typography>
            </Box> */}
            <Box>
              <Typography
                sx={{ color: "#F64E60", fontWeight: "600", fontSize: "18px" }}
              >
                {Props?.data?.close_count}
              </Typography>
              <Typography>Closed Defect</Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default FullViewDonutChart;
